import React from "react";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import {
	Container,
	Title,
	Company,
	Designation,
	ImageContainer,
	TypeImageContainer,
	Icon,
} from "./styles";
const AliumniCard = ({ data, onClick, isOnlyVideoCard, id }) => {
	const { alumni_data } = data;

	const videoIcon = `https://res.cloudinary.com/springboard-images/image/upload/v1635324684/Student%20Success/Icon/video-camera_1.png`;
	const normalIcon = `https://res.cloudinary.com/springboard-images/image/upload/v1635324684/Student%20Success/Icon/open-book_1.png`;
	return (
		<Container
			onClick={() => {
				onClick();
			}}
		>
			<ImageContainer>
				<TypeImageContainer video={isOnlyVideoCard}>
					<Icon>
						<CloudinaryImage
							className="icon-image"
							url={isOnlyVideoCard ? videoIcon : normalIcon}
							quality="auto"
							lazyload
							fetchFormat="auto"
							drp="1.0"
							sizes={{
								default: {
									width: 21,
								},
							}}
							alt={`icon`}
							key={`${alumni_data?.avatar?.image}-${id}`}
							dynamic
						/>
					</Icon>
				</TypeImageContainer>
				<CloudinaryImage
					className="alumni-image"
					lazyload
					url={alumni_data?.avatar?.image}
					sizes={{ default: { height: 200 } }}
					key={`${alumni_data?.avatar?.image}-${id}`}
				/>
			</ImageContainer>
			<Title>{alumni_data?.name}</Title>
			<Designation>{alumni_data?.designation}</Designation>
			<Company>{alumni_data?.company}</Company>
		</Container>
	);
};

export default AliumniCard;
